import { Button } from 'primereact/button';

function CircumstanceItem({ circumstance, handleClickCircumstance, handleDeleteCircumstance }) {
  return (
    <div
      className="flex flex-row items-center py-5 px-3 gap-x-5 cursor-pointer hover:bg-slate-100 w-full border-b border-slate-200 last:border-b-0"
      onClick={handleClickCircumstance}>
      {circumstance.images.map((image) => (
        <img className="h-32 block rounded-md" src={image.file} alt={image.title} />
      ))}
      <div className="flex flex-col justify-around h-full w-full">
        <div className="text-xl font-bold  ">{circumstance.title}</div>
        <div className="text-base font-medium  ">{circumstance.description}</div>
      </div>

      <Button
        key={'delete'}
        icon="pi pi-trash"
        outlined
        rounded
        onClick={(e) => {
          e.stopPropagation();
          handleDeleteCircumstance();
        }}
        severity="danger"
        className="h-10 w-10 min-h-10 min-w-10"
      />
    </div>
  );
}

export default CircumstanceItem;
